
























































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Mutation, State, Getter } from 'vuex-class'
import { Post, PostTranslation } from '@/modules/blog/types'
import LocaleSelectComponent from '@/modules/i18n/components/LocaleSelect.vue'
import { Product } from '@/modules/product';
import UnigestLanguage from '@/modules/product/model/UnigestLanguage';
import Locale from '@/modules/i18n/model/Locale';

/**
 * Selección de traducción
 *
 * Componente mostrado en la pantalla de edición del producto de Unigest,
 * permite seleccionar la traducción a editar y añadir una nueva
 * seleccionando uno de los localismos registrados en la
 * aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'locale-select': LocaleSelectComponent,
    },
})
export default class ProductTranslationSelector extends Vue {

    @State(state => state.product.unigestLanguages)
    public unigestLanguages: UnigestLanguage[]

    /**
     * Localismos registrados en la aplicación
     */
    @State(state => state.i18n.locales)
    public locales: Locale[]

    /**
     * Cambia la traducción que actualmente esta editando la pantalla de edición
     * de la publicación
     */
    @Mutation('product/product/locale/current/set')
    public setCurrentLocale: (locale: string) => void

    /**
     * Añade o modifica una traducción del articulo en edición
     */
    @Mutation('product/product/translation/add')
    public addTranslation: (locale: string) => void

    @Getter('i18n/worldLocaleName')
    public localeName: (identifier: string) => string

    /**
     * Traducción actual
     *
     * Propiedad que almacena el localismo de la la traducción actualmente en
     * edición
     */
    get currentTranslation () {
        return this.$store.state.product.currentLocale
    }

    set currentTranslation (value: string) {
        this.setCurrentLocale(value)
    }

    /**
     * Artículo actual
     */
    @State(state => state.product.currentProduct)
    public product: Product

    public localeSelection = false
    public selectedLocale: Locale | null  = null


    /**
     * Filtros para la selección de idiomas
     *
     * Indica al selector de localismos SOLO incluya los localismos que poseen
     * un equivalentes en Unigest y todavia no han sido registrados como
     * traducción
     */
    get localeSelectFilters (): object {
        const locales = this.locales.map(l => l.identifier)
        const unigestLanguages = this.unigestLanguages.map(l => l.locale)
        const intersection = _.intersection(locales, unigestLanguages)

        const alreadyRegisteredTranslations = this.product.translations.map(t => t.locale)

        return {
            policy: 'include',
            identifiers: intersection.filter(l => alreadyRegisteredTranslations.indexOf(l) < 0),
        }
    }

    /**
     * Registra una nueva traducción en la publiación
     */
    public createNewTranslation (locale: Locale) {
        this.addTranslation(locale.identifier)
    }


    /**
     * Confirmar selección
     */
    public confirm () {
        this.createNewTranslation(this.selectedLocale!)
        this.selectedLocale = null
        this.localeSelection = false
    }
}
